import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { MessagingQueryKey } from '../../keys'
import MessagingService from '../services'
import { GetAutoMessageResponse } from '../../types'

function useQueryGetAllAutoMessages(
	props?: UseBaseQueryOptions<GetAutoMessageResponse[]>,
) {
	return useQuery({
		queryKey: [MessagingQueryKey.GetAllAutoMessages],
		queryFn: () => MessagingService.getAllAutoMessages(),
		...props,
	})
}

export default useQueryGetAllAutoMessages
